import ExportModal, { ExportModalProps } from './ExportModal'
import { createExportColumnHelper } from 'components/DataExpansionComponents/Common/commonColumnHelpers'
import { getCommonChainProxyExportColumns } from 'components/DataExpansionComponents/Common/commonExportColumns'
import { CONVENIENCE_COLUMNS } from 'components/DataExpansionComponents/GooglePlaces/Convenience/ConvenienceColumnsInfo'

export default function ConvenienceExportModal(props: ExportModalProps) {
  const dataTypeName = 'Convenience Stores'

  const convenienceHomeColumnHelper = createExportColumnHelper({
    columns: CONVENIENCE_COLUMNS,
  })

  const columns = [
    {
      title: 'Opportunity Attributes',
      elements: [
        convenienceHomeColumnHelper.retrieveColumn('name'),
        convenienceHomeColumnHelper.retrieveColumn('city_summary'),
        convenienceHomeColumnHelper.retrieveColumn('state_summary'),
        convenienceHomeColumnHelper.retrieveColumn('zipcode_summary'),
        convenienceHomeColumnHelper.retrieveColumn('domain'),
        convenienceHomeColumnHelper.retrieveColumn('reviews_avg'),
        convenienceHomeColumnHelper.retrieveColumn('reviews_cnt'),
        convenienceHomeColumnHelper.retrieveColumn('open_hours'),
        convenienceHomeColumnHelper.retrieveColumn('doors_cnt'),
      ],
    },
    {
      title: 'Predicted Values and Deals',
      elements: getCommonChainProxyExportColumns(),
    },
  ]

  return (
    <ExportModal
      title={`Select Columns for ${dataTypeName} Download`}
      subTitle={`Download up to 10,000 ${dataTypeName.toLocaleLowerCase()} at a time, with any of the following columns. Any filters already applied will remain active.`}
      submitText={`Export ${dataTypeName}`}
      columns={columns}
      {...props}
    />
  )
}
